import App from "./App";
import PreLogin from "./page/preLogin/PreLogin";
import {Routes} from "./components/routes/Routes";
import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { setAuthToken, setUserIdHeader, sessionLoginApi, setSessionIdHeader } from "./network/ApiService";
import { IESAuthUtilV2 } from "@activehub/common-components-spa";
import { IESConfig, IESOptions } from "./constants/IESConfig";

function getSessionIdFromCookie() {
    const match = document.cookie.match(/(^|;\s*)sessionId=([^;]*)/);
    return match ? decodeURIComponent(match[2]) : null;
}

function isSessionIdForUser(sessionId, userId) {
console.log("log isSessionIdForUser", sessionId, userId);
  if (!sessionId || !userId) {
    return false;
  }

  return sessionId.startsWith(`${userId}_`);
}

export const AuthenticationContext = createContext(null);

export function AccessAndAdminApp() {

  const [isTokenExist, setIsTokenExist] = useState(false);
  const [authToken, setAuthTokenState] = useState("");
  const [iesSession, setIesSession] = useState(null);
  const [userId, setUserId] = useState(null);
  const [hasFatalError, setHasFatalError] = useState(false);

  const setToken = useCallback((tokenValue) => {
    setAuthToken(tokenValue);
    setAuthTokenState(tokenValue || "");
    window.GATEWAY = Object.assign(window.GATEWAY || {}, { authToken: tokenValue || "" });
  }, []);

  const ensureSessionForUser = useCallback((session, currentUserId, errorMessage) => {
    console.log("log ensureSessionForUser", session, currentUserId);
    const existingSessionId = getSessionIdFromCookie();
    console.log("log getSessionIdFromCookie", existingSessionId);

    if (isSessionIdForUser(existingSessionId, currentUserId)) {
        console.log("log isSessionIdForUser if", existingSessionId, currentUserId);
      setSessionIdHeader(existingSessionId);
      setIsTokenExist(true);
      return;
    }
    console.log("log isSessionIdForUser if after");
    sessionLoginApi(currentUserId).subscribe(
      (response) => {
        console.log("sessionLoginApi")
        setSessionIdHeader(response?.sessionId);
        setIsTokenExist(true);
      },
      (error) => {
        console.error(errorMessage, error);
        session.logout();
        setIsTokenExist(true);
      }
    );
  }, []);

  useEffect(() => {
    const loginTypeVal = sessionStorage.getItem("LOGINTYPE");
    const loginParams = (loginTypeVal) ? { queryParams: { loginType: loginTypeVal } } : {};
    const iesSubscription = IESAuthUtilV2.load({
      ...IESConfig,
      callbackURL: `${window.location.href}`,
      domain: window.location.hostname,
      ...loginParams
    }, IESOptions).subscribe((session) => {
      if (!window.location.hash.includes('login')) {
        session.login();
      }
      setIesSession(session);
      if (session.hasValidSession()) {   
        const currentUserId = session.getUserId();
        setUserId(currentUserId);
        setUserIdHeader(currentUserId);
        session.getToken((status, token) => {
          if (status === session.Status.Success) {
            setToken(token);
            console.log("log line 80", session.getUserId(), currentUserId);
            ensureSessionForUser(session, session.getUserId(), 'Session login failed:');
          }
        });
      }
           
      session.onRefresh((refreshEvent) => {
        if (refreshEvent.data) {
          setUserId(session.getUserId());
          setUserIdHeader(session.getUserId());
          setToken(refreshEvent.data);
        }
      });
      session.onLogin(() => {
        const currentUserId = session.getUserId();
        setUserId(currentUserId);
        setUserIdHeader(currentUserId);
        session.getToken((status, token) => {
          if (status === session.Status.Success) {
            setToken(token);
            console.log("log line 102", session.getUserId(), currentUserId);
            ensureSessionForUser(session, session.getUserId(), 'Session login failed on login event:');
          } else {
            // Token retrieval failed inside onLogin, allow app to proceed
            setIsTokenExist(true);
          }
        });
      });
    }, 
    (error) => {
      setHasFatalError(true)
    });

    return () => iesSubscription.unsubscribe();
    // no need to call ies again if setters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ensureSessionForUser, setToken]);

    const baseRoutes = useMemo(() => {
        return [
            {
                component: App,
                path: "/application/:applicationId?",
                exact: false,
                title: "Global Gateway Wrapper",
            },
            {
                component: PreLogin,
                path: "/login",
                exact: false,
                title: "Pre Login Page"
            }
        ]
    }, [])

    const authenticationContextValues = useMemo(() => {
        return {
            iesSession,
            userId,
        authToken,
            isTokenExist,
            hasFatalError,
            setIsTokenExist
        }
    }, [iesSession, userId, authToken, isTokenExist, hasFatalError])

    

    return (
        <AuthenticationContext.Provider value={authenticationContextValues}>
            <Routes routes={baseRoutes} defaultRoute={baseRoutes[0].path} />
        </AuthenticationContext.Provider>
    );
}
